import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {phone as phoneNormalize} from 'phone';
import settings from '../../config/settings';
import * as BrowserUtils from '../utils/BrowserUtils';
import EmbedVideo from './EmbedVideo';
import * as CardUtils from '../utils/CardUtils';
import {cardLoadMode, cardStyles} from '../const/VuCardConst';
import {injectHtml} from '../utils/DomUtils';
import {getImageUrl} from '../utils/ApiUtils';
import SubscriptionApi from '../api/SubscriptionApi';
import ReactPhoneInput from 'react-phone-input-2';
import InputValidator from '../common/InputValidator';
import ValidatedComponent from '../common/ValidatedComponent';
import * as ErrorUtils from '../utils/ErrorUtils';

class VuCardTextReminder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: false,
      device: '',
      phone: '',
      isSubscribed: false,
      errors: {}
    };

    this.callToActionContainer = null;
    this.phoneInput = null;
    this.submitBtn = null;
  }

  componentDidMount() {
    // workaround to assure phone input is fucused with cursor at the end
    if (this.submitBtn && this.phoneInput) {
      this.submitBtn.focus();
      setTimeout(() => this.phoneInput && this.phoneInput.cursorToEnd(), 200);
    }

    const device = BrowserUtils.getDeviceType();

    this.setState({
      isMobile: BrowserUtils.isMobile.any(),
      device,
    });

    this.applyCallToAction();
  }

  applyCallToAction() {
    const {callToAction} = this.props.record;

    if (callToAction) {
      const wrapper = document.createElement('span');
      this.callToActionContainer.appendChild(wrapper);
      injectHtml(wrapper, callToAction);
    }
  }

  render() {
    const {record} = this.props;
    const {isMobile, isSubscribed} = this.state;
    const mediaConfig = this.getMediaConfig();

    if (!record) {
      return null;
    }

    let contentStyle = null;
    if (this.getBackgroundVideo() && !isMobile) {
      contentStyle = {backgroundColor: 'transparent', overflow: 'hidden'};
    } else if (this.hasBackgroundImage()) {
      contentStyle = {
        background: `url(${getImageUrl(record.backgroundImage)}) center center fixed`,
        backgroundSize: 'cover'
      };
    } else if (_.get(record, 'backgroundColor')) {
      contentStyle = {backgroundColor: record.backgroundColor};
    }

    return (
      <div className="vuCard__content"
           style={contentStyle}>
        {
          this.renderBackgroundVideo()
        }
        <div className="vuCard__content__movie">
          {
            !record.hideTitle &&
            <div className="vuCard__content__movie__title">
              {record.title}
            </div>
          }
          {
            (mediaConfig.videoUrl || mediaConfig.videoImg) ?
              <div className="vuCard__content__movie__video">
                {this.renderPreviewVideo(mediaConfig)}
              </div>
              : null
          }
          {
            mediaConfig.posterUrl ?
              <div className="vuCard__content__movie__cover">
                <img src={mediaConfig.posterUrl} alt={`${record.title} Poster`}/>
              </div>
              : null
          }
          <div className="vuCard__content__line"/>
        </div>
        <div className="vuCard__content__select">
          {
            this.setCustomStylesForCta()
          }
          {
            !isSubscribed ?
              <React.Fragment>
                {
                  this.renderCta()
                }
                {
                  this.renderPhoneSubmissionForm(record)
                }
              </React.Fragment>
              :
              this.renderThankYouMessage()
          }
        </div>
        {
          this.renderAbout()
        }
      </div>);
  }

  renderBackgroundVideo() {
    const videoUrl = this.getBackgroundVideo();

    if (videoUrl && !this.state.isMobile) {
      return (
        <video className="vuCard__content__backgroundVideo"
               preload="metadata"
               style={{
                 height: 'auto',
                 width: 'auto',
                 minHeight: '100%',
                 minWidth: '100%',
                 position: 'absolute',
                 top: '50%',
                 left: '50%',
                 transform: 'translate(-50%, -50%)',
                 zIndex: -100,
                 transition: '1s opacity'
               }}
               src={videoUrl}
               playsinline
               autoPlay
               muted
               loop/>
      );
    }
  }

  hasBackgroundAsset() {
    return !!this.getBackgroundVideo() || this.hasBackgroundImage();
  }

  getBackgroundVideo() {
    const {record} = this.props;
    return record.backgroundVideo;
  }

  hasBackgroundImage() {
    const {record} = this.props;
    return !!getImageUrl(record.backgroundImage);
  }

  getProviderButtonStyle() {
    return this.hasBackgroundAsset() ? {backgroundColor: 'rgba(0, 0, 0, 0.5)'} : null;
  }

  setCustomStylesForCta() {
    const {callToActionColor} = this.props.record;

    if (callToActionColor) {
      return (
        <style dangerouslySetInnerHTML={{
          __html: `
.vuCard__content__select__cta {
  color: ${callToActionColor};
}
`
        }}/>
      );
    }
  }

  renderCta() {
    return (
      <div className="vuCard__content__select__cta"
           ref={(node) => {
             this.callToActionContainer = node;
           }}
      />);
  }

  renderPhoneSubmissionForm() {
    const {phone, errors} = this.state;
    return (
      <form noValidate onSubmit={this.handlePhoneSubmit} className="vuCard__content__select__subscriptionForm">
        <label htmlFor="phone-input">Mobile #</label>
        <InputValidator customValidation={this.validatePhoneNumber}
                        className="vuCard__content__select__subscriptionForm__phone"
                        errors={errors.phone}>
          <ReactPhoneInput
            inputExtraProps={{
              name: 'phone',
              required: true,
              autoFocus: false,
              onFocus: (e) => {
                const val = e.target.value;
                e.target.value = '';
                e.target.value = val;
              }
            }}
            disableDropdown
            defaultCountry="us"
            value={phone}
            onChange={this.setPhone}
            ref={(input) => {
              this.phoneInput = input;
            }}
          />
        </InputValidator>
        <button type="submit"
                className="vuCard__content__select__subscriptionForm__submit"
                ref={(btn) => {
                  this.submitBtn = btn;
                }}>
          Submit
        </button>
      </form>
    )
      ;
  }

  validatePhoneNumber = () => {
    const {phone} = this.state;
    const res = phoneNormalize(phone);
    if (!res.isValid) {
      return 'Please enter a valid phone number';
    }
  }

  setPhone = (phone) => {
    this.setState({phone});
  }

  handlePhoneSubmit = async (e) => {
    e.preventDefault();
    if (this.context.isComponentValid()) {
      const {phone} = this.state;
      const {record} = this.props;

      try {
        const normalized = phoneNormalize(phone);
        await SubscriptionApi.requestSubscription(normalized.phoneNumber, record.id);
        this.setState({isSubscribed: true});
      } catch (e) {
        this.setState({errors: ErrorUtils.getApiErrors(e)});
      }
    }
  }

  renderThankYouMessage() {
    return (
      <div className="vuCard__content__select__cta">
        <p><b>Thank you!</b></p>
        <p>You will receive a text in a few days when the limited edition sign is back in stock.</p>
      </div>);
  }

  getMediaConfig() {
    const {record, mode} = this.props;
    const posterUrl = CardUtils.getHorizontalPosterImageUrl(record);
    const videoUrl = CardUtils.getPosterVideoUrl(record);
    const videoImg = posterUrl;

    if (mode === cardLoadMode.preview && record.isVideoPreviewBlocked) {
      return {videoUrl, videoKind: 'upload', videoImg: _.get(settings, 'create.logoUrl', '/static/logo.png')};
    }

    return videoUrl ? {videoUrl, videoKind: record.posterVideo.kind, videoImg} : {posterUrl};
  }

  renderPreviewVideo(config) {
    const {isVisible} = this.props;

    if (!isVisible) return null;

    return (
      <EmbedVideo url={config.videoUrl}
                  kind={config.videoKind}
                  poster={config.videoImg}/>);
  }

  renderAbout() {
    return (
      <a className="vuCard__content__about"
         href="https://vupulse.com/"
         target="_blank"
         rel="noopener noreferrer">
        About VuPulse
      </a>
    );
  }
}

VuCardTextReminder.propTypes = {
  record: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  mode: PropTypes.oneOf(Object.values(cardLoadMode)),
  rendererId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  renderer: PropTypes.object,
  isPreloaded: PropTypes.bool.isRequired
};

VuCardTextReminder.defaultProps = {
  shareUrl: '',
  cardStyle: cardStyles.classic,
  isPreloaded: false
};

export default ValidatedComponent(VuCardTextReminder);
